export class PropertyEnrichmentApi {
  #http;

  constructor(http) {
    this.#http = http;
  }

  async getPropertyEnrichment({ reapiPropertyId, address }) {
    return this.#http.get('/api/admin/property-enrichment', {
      params: { reapiPropertyId, address },
    });
  }

  async updateReapiPropertyId({ propertyId, reapiPropertyId }) {
    return this.#http.patch('/api/admin/property-enrichment/reapi-property-id', null, {
      params: { propertyId, reapiPropertyId },
    });
  }
}
